import { Component, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { IFormTypes } from '../../data/form-types';
import { ApplicantDetails } from '../../data/applicant-details';
import { LookupItem } from '../../models/lookup-item';
import { Observable } from 'rxjs';
import { IFileUploadResult } from '../../models/i-file-upload-result';
import { IFormComponent } from '../../models/i-form-component';
import { IVisaType } from '../../data/visa-type';
import { OptionItem } from '../../data/option-item';

@Component({
  selector: 'app-general-enquiry',
  templateUrl: './general-enquiry.component.html',
  styleUrl: './general-enquiry.component.scss'
})
export class GeneralEnquiryComponent implements OnInit,IFormComponent {
 
  @Input()model!: InitialAssessmentForm;
  @Input()formTypes!: IFormTypes;
  @Input()educationLevels!: LookupItem[];
  @Input() countries!: LookupItem[];
  @Input() visaTypes!: IVisaType[];
  @Input() titles!: LookupItem[];
  @Input() maritalStatus!: LookupItem[];
  @Input() phoneTypes!: OptionItem[];
  @Input() isAddressForced!: boolean;
  @Output() formReady = new EventEmitter<FormGroup>();

    @ViewChild('businessEnquiryForm') businessEnquiryFormComponent?: any;
    @ViewChild('feedbackForm') feedbackFormComponent?: any;
    @ViewChild('dataProtectionForm') dataProtectionFormComponent?: any;
    @ViewChild('applicantDetailsForm') applicantDetailsComponent?: any;
    

  educationLevels$!: Observable<LookupItem[]>;

  formBuilder = inject(NonNullableFormBuilder);

  submitAttempted = false;

  generalEnquiryForm = this.formBuilder.group({
    enquiryType: ['', Validators.required],
    partnerCitizen: [''],
    occupation: [''],
    education: [null as LookupItem | null],
    hasJobOffer: ['']
    
  });

  constructor() { }

  ngOnInit(): void {
    
    this.initializeForm();
    this.updateValidatorsBasedOnEnquiryType();
    this.generalEnquiryForm.controls.enquiryType.valueChanges.subscribe(() => {
    this.clearAllFormErrors();
  });
    this.formReady.emit(this.generalEnquiryForm);
  }

  initializeForm() {
   
    this.model = this.model || new InitialAssessmentForm();
    this.model.applicantDetails = this.model.applicantDetails || new ApplicantDetails();

    this.generalEnquiryForm.patchValue({
      enquiryType: this.model.enquiryType || '',
      partnerCitizen: this.model.applicantDetails.partnerCitizen || '',
      occupation: this.model.applicantDetails.Occupation || '',
      education: this.model.applicantDetails.education || null,
      hasJobOffer: this.model.applicantDetails.hasJobOffer || ''
    });

    this.generalEnquiryForm.valueChanges.subscribe(formValues => {
      this.model.enquiryType = formValues.enquiryType || '';
      this.model.applicantDetails!.partnerCitizen = formValues.partnerCitizen || '';
      this.model.applicantDetails!.Occupation = formValues.occupation || '';
      this.model.applicantDetails!.education = formValues.education || null;
      this.model.applicantDetails!.hasJobOffer = formValues.hasJobOffer || '';
      this.updateValidatorsBasedOnEnquiryType();
    }


    );

  }

private clearAllFormErrors(): void {
  this.submitAttempted = false;

  this.resetFormState(this.generalEnquiryForm);
  this.resetFormState(this.businessEnquiryFormComponent?.businessEnquiryForm);
  this.resetFormState(this.feedbackFormComponent?.feedbackForm);
  this.resetFormState(this.dataProtectionFormComponent?.dataProtectionForm);
  this.resetFormState(this.applicantDetailsComponent?.applicantDetailsForm);
}

private resetFormState(form?: FormGroup): void {
  if (!form) return;

  form.markAsPristine();
  form.markAsUntouched();

  Object.values(form.controls).forEach(control => {
    control.markAsPristine();
    control.markAsUntouched();
    control.updateValueAndValidity({ emitEvent: false });
  });

  form.updateValueAndValidity({ emitEvent: false });
}

  updateValidatorsBasedOnEnquiryType() {
    const enquiryType = this.generalEnquiryForm.controls.enquiryType.value;
    const partnerCitizenControl = this.generalEnquiryForm.controls.partnerCitizen;
    const occupationControl = this.generalEnquiryForm.controls.occupation;
    const hasJobOfferControl = this.generalEnquiryForm.controls.hasJobOffer;

    if (enquiryType === 'visa') {
      partnerCitizenControl.setValidators([Validators.required]);
      occupationControl.setValidators([Validators.required]);
      hasJobOfferControl.setValidators([Validators.required]);
    } else {
      partnerCitizenControl.clearValidators();
      occupationControl.clearValidators();
      hasJobOfferControl.clearValidators();
    } 
    this.generalEnquiryForm.updateValueAndValidity({ emitEvent: false });

  }


  onChildFormReady(childForm: FormGroup) {
    this.formReady.emit(childForm);
  }

  onFileUploaded(fileResult: IFileUploadResult | null): void {
    console.log('File uploaded:', fileResult);
    
    if (fileResult) {
         this.model.applicantDetails!.resumeFile = [{ name: fileResult.file.name, size: fileResult.file.size, type: fileResult.file.type, key: fileResult.key }];
         this.model.applicantDetails!.resumeLocation = fileResult.fileId;
    } else {
          this.model.applicantDetails!.resumeFile = [];
          this.model.applicantDetails!.resumeLocation = '';
    }
  }

  isFormValid(): boolean {
    // if we get here it means the button bar is checking the formValid after clicking submit.
    this.submitAttempted = true;
    const businessEnquiryFormValid = this.businessEnquiryFormComponent?.businessEnquiryForm.valid ?? true;
    const feedbackFormValid = this.feedbackFormComponent?.feedbackForm.valid ?? true;
    const dataProtectionFormValid = this.dataProtectionFormComponent?.dataProtectionForm.valid ?? true;
    const applicantDetailsFormValid =
    this.generalEnquiryForm.controls.enquiryType.value === 'visa' || this.generalEnquiryForm.controls.enquiryType.value === 'other'
      ? (this.applicantDetailsComponent?.applicantDetailsForm.valid ?? false)
      : true;
    
  return applicantDetailsFormValid
    && businessEnquiryFormValid
    && feedbackFormValid
    && dataProtectionFormValid
    && this.generalEnquiryForm.valid;
  }

  markFormAsTouched(): void {
    this.businessEnquiryFormComponent?.businessEnquiryForm?.markAllAsTouched();
    this.feedbackFormComponent?.feedbackForm?.markAllAsTouched();
    this.dataProtectionFormComponent?.dataProtectionForm?.markAllAsTouched();
    this.generalEnquiryForm.markAllAsTouched();
    if (this.generalEnquiryForm.controls.enquiryType.value === 'visa' || this.generalEnquiryForm.controls.enquiryType.value === 'other') {
      this.applicantDetailsComponent?.applicantDetailsForm?.markAllAsTouched();
    } 
  }


}
